module.exports = __webpack_public_path__ + "static/p-1-09e3ca0d6c18615761f5a706be89cfd1.png";